import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { portalApi, setCsrf } from './api';

const AuthContext = createContext(null);
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const acceptSession = useCallback(data => { setUser(data.user); setCsrf(data.csrf_token); }, []);
  const refresh = useCallback(async () => {
    try { const { data } = await portalApi.get('/auth/session'); acceptSession(data); }
    catch { setUser(null); setCsrf(null); }
    finally { setLoading(false); }
  }, [acceptSession]);
  useEffect(() => { refresh(); }, [refresh]);
  const logout = async () => { await portalApi.post('/auth/logout'); setUser(null); setCsrf(null); };
  return <AuthContext.Provider value={{ user, loading, acceptSession, refresh, logout, setUser }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => useContext(AuthContext);